// Attention list (approved HTML component: executive-attention).
import type { ReactNode } from 'react';
import type { AttentionItem } from '../mockData.js';

export interface ExecutiveAttentionProps {
  items: AttentionItem[];
  onOpen?: (item: AttentionItem) => void;
}

export function ExecutiveAttention({
  items,
  onOpen,
}: ExecutiveAttentionProps): ReactNode {
  return (
    <section className="attention-card" data-component="executive-attention">
      <span className="eyebrow">ATTENTION NOW</span>
      <h3>Three things worth your attention.</h3>
      <p>Exceptions and changes for the selected period.</p>
      <div className="attention-list">
        {items.map(item => (
          <div key={item.idx}>
            <i className={item.severity === 'red' ? 'red' : ''} />
            <div>
              <strong>{item.title}</strong>
              <small>{item.body}</small>
              <button
                type="button"
                className="exec-text-button"
                data-attention={item.idx}
                onClick={() => onOpen?.(item)}
              >
                View detail <span aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
